import {
    apiRequest,
    settingCronList,
    settingCronInactive,
    settingCronActive,
    settingCronHistory,
    settingCronForce,
    settingCronCancel,
} from "../../../../../services/adapters/base"

class DataTableRepository {
    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest(
            "get",
            settingCronList,
            {
                cancelToken: cancelToken,
                params: query,
            },
            true
        )
    }

    fetchHistory = async (query) => {
        return await apiRequest(
            "get",
            settingCronHistory,
            {
                params: query,
            },
            true
        )
    }

    fetchInactive = async (query) => {
        return await apiRequest(
            "post",
            settingCronInactive,
            {
                body: query,
            },
            true
        )
    }
    fetchActive = async (query) => {
        return await apiRequest(
            "post",
            settingCronActive,
            {
                body: query,
            },
            true
        )
    }

    fetchForce = async (query) => {
        return await apiRequest(
            "post",
            settingCronForce,
            {
                body: query,
            },
            true
        )
    }

    fetchCancel = async (query) => {
        return await apiRequest(
            "post",
            settingCronCancel,
            {
                body: query,
            },
            true
        )
    }
}

export default DataTableRepository
